export default __webpack_public_path__ + "static/media/Leggings of the Firebrand.e5bc7e14.jpg";